var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4914_20585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02571 0 0 4.02525 0 9C0 13.9742 4.02525 18 9 18C13.9743 18 18 13.9747 18 9C18 4.02571 13.9747 0 9 0ZM9 16.7442C4.72985 16.7442 1.25582 13.2702 1.25582 9C1.25582 4.72982 4.72985 1.25582 9 1.25582C13.2702 1.25582 16.7442 4.72982 16.7442 9C16.7442 13.2702 13.2702 16.7442 9 16.7442Z",
    fill: "#2376BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73629 11.3879C8.23872 11.3879 7.83594 11.8026 7.83594 12.3001C7.83594 12.7859 8.22688 13.2123 8.73629 13.2123C9.2457 13.2123 9.64845 12.7859 9.64845 12.3001C9.64845 11.8026 9.23382 11.3879 8.73629 11.3879Z",
    fill: "#2376BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88459 4.48132C7.28527 4.48132 6.55078 5.4291 6.55078 6.0688C6.55078 6.53083 6.94172 6.74408 7.26157 6.74408C7.90131 6.74408 7.6407 5.83185 8.84905 5.83185C9.44136 5.83185 9.91527 6.0925 9.91527 6.63746C9.91527 7.27716 9.25184 7.6444 8.8609 7.9761C8.51732 8.27222 8.06718 8.75798 8.06718 9.7768C8.06718 10.3928 8.23304 10.5705 8.71873 10.5705C9.29919 10.5705 9.41767 10.3099 9.41767 10.0848C9.41767 9.46876 9.42952 9.11337 10.0811 8.60396C10.401 8.35519 11.4079 7.54958 11.4079 6.43601C11.4079 5.32244 10.401 4.48132 8.88459 4.48132Z",
    fill: "#2376BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4914_20585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.e5bf5893316aa4d78d3c8e52567c176b.svg";
export { ForwardRef as ReactComponent };